var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-title-wrapper"},[_c('keep-alive',[_c(_vm.currentComponentName,{tag:"component",attrs:{"name":_vm.titleName,"theme":_vm.titleTheme,"type":_vm.moduleType,"width":_vm.width}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }